import React, { useState } from "react";
import {
  Card,
  Box,
  MenuItem,
  FormControl,
  Select,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { CustomNoRowsOverlay } from "../Assessment.js";
import moment from "moment/moment";
import IssueSideBar from "../VendorDetail/IssueSideBar.js";
import CustomPagination from "../../components/common/customPagination.jsx";
import { ModeComment } from "@mui/icons-material";

function IssuesAdmin({
  issuesListData
}) {
  const [openSidebar, setOpenSidebar] = React.useState(false);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const handlePaginationModelChange = (newPaginationModel) => {
    setPaginationModel(newPaginationModel);
  };
  const [selectedIssue, setSelectedIssue] = useState({})

  const columnsNew = [
    {
      field: "id",
      headerName: "#",
      flex: 0.5,
      sortable: false,
      className: "serial-number",
      disableColumnMenu: true,
    },
    {
      field: "name",
      headerName: "Issue Name",
      flex: 1.1,
      minWidth: 170, // Ensure minimum width
      disableColumnMenu: true,
    },
    {
      field: "category",
      headerName: "Category",
      flex: 1,
      minWidth: 125,
      disableColumnMenu: true,
    },
    {
      field: "severity",
      headerName: "Severity",
      flex: 1,
      minWidth: 100,
      disableColumnMenu: true,
      renderCell: (params) => {
        let scoreTag = "-";
        const severity = params.row.severity
        if (severity === 'low')
          scoreTag = "Low";
        if (severity === 'medium')
          scoreTag = "Medium";
        if (severity === 'critical')
          scoreTag = "Critical";
        else if (severity === 'high')
          scoreTag = "High";

        return (
          scoreTag ? (
            <span className={`tagClassapproval blank-white ${scoreTag}`}>
              <span>{scoreTag}</span>
            </span>
          ) : (
            "-"
          )
        );
      },
    },
    {
      field: "foundAt",
      headerName: "Found",
      flex: 1,
      minWidth: 100,
      disableColumnMenu: true,
      renderCell: (p) => {
        return <>{p.value ? moment(p.value)?.format("DD/MM/YYYY") : "-"} </>;
      },
    },
  ];

  const filteredRows =
    (!issuesListData || !issuesListData.length) ? [] :
      issuesListData
        .filter(val => val.name && val.name != "" && val.name != null && val.name.toLowerCase() != "null")
        ?.map((val, i) => ({
          ...val,
          id: i + 1,
        }));

  const handleRowClick = (params) => {
    setSelectedIssue(params?.row)
    setOpenSidebar(true)
  };

  return (
    <>
      {/* <Loader show={loading} /> */}
      <Card className="full-coverdesign margin-questionnaire">
        <div className="cover-table">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              position: "relative",
              top: "0px",
              left: "8px",
            }}
          >
            <FormControl
              className="select-entries"
              variant="outlined"
              size="small"
            >
              <Select
                value={paginationModel.pageSize}
                onChange={(e) => handlePaginationModelChange({ page: 0, pageSize: e.target.value })}
              >
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={25}>25</MenuItem>
              </Select>
            </FormControl>
            <span className="entries-per">entries per page</span>{" "}
          </div>
          <div className="issues-tab-table">
            <Box
              sx={{
                width: "100%",
                "& .MuiDataGrid-columnHeaders": {
                  minWidth: "100%",
                  overflowX: "hidden",
                },
                "& .MuiDataGrid-virtualScroller": {
                  minWidth: "100%",
                  overflowX: "auto",
                },
              }}
            >

              <DataGrid
                loading={false}
                rows={filteredRows}
                columns={columnsNew}
                rowHeight={70}
                onPaginationModelChange={handlePaginationModelChange}
                paginationModel={paginationModel}
                pageSizeOptions={[5, 10, 25]}
                slots={{
                  toolbar: GridToolbar,
                  noRowsOverlay: CustomNoRowsOverlay,
                  pagination: CustomPagination,
                }}
                slotProps={{
                  pagination: {
                    paginationModel,
                    onPaginationModelChange: handlePaginationModelChange,
                    rowCount: filteredRows?.length
                  },
                }}
                disableRowSelectionOnClick
                disableColumnFilter
                disableColumnSelector
                disableDensitySelector
                disableColumnMenu
                paginationMode="client"
                disableSelectionOnClick
                autoHeight
                className="datagrid-table click-hover-datagrid"
                sx={{
                  "& .MuiDataGrid-columnHeaders": {
                    minWidth: "100%", // Column headers take up full width
                  },
                  "& .MuiDataGrid-virtualScroller": {
                    minWidth: "100%", // Rows take up full width
                  },
                }}
                onRowClick={handleRowClick}
              />
            </Box>
          </div>
        </div>
      </Card>
      {openSidebar &&
        <IssueSideBar
          issueData={selectedIssue}
          handleClose={() => setOpenSidebar(false)}
          open={openSidebar}
        />
      }
    </>
  );
}

export default IssuesAdmin;
